module.exports = __webpack_public_path__ + "static/media/power-off.3a788a41.svg";